module.exports = __webpack_public_path__ + "static/requirements-9d83778f118046ede75c8143f8e726c4.pdf";